import styles from './CorridorConfigurator.styl'
import Image from './ui/features/Image.jsx'
import React, {useEffect, useState} from 'react'
import CheckBoxWithHeader from './ui/features/CheckBoxWithHeader/CheckBoxWithHeader.jsx'
import Input from './ui/features/Input/Input.jsx'
import DropDown from './ui/features/DropDown/DropDown.jsx'
import RadioGroup from './ui/features/RadioGroup/RadioGroup.jsx'
import jQuery from 'jquery'
import {delDuplicatesFromArray} from './Helpers/Helpers'
import Button from './ui/button/Button.jsx'
import Table from "./ui/features/Table.jsx";
import Popup from './ui/features/Popup/Popup.jsx'
import Modal from './ui/features/ModalForm.jsx'

const FEET = 'На ножках'
const NO_FEET = 'Без ножек'
const EXTERNAL = 'Внешний'
const INTERNAL = 'Внутренний'
const ISOLATED = 'Изолированный'
const NOT_ISOLATED = 'Не изолированный'
const ONE_WAY = 'С одним входом'
const TWO_WAYS = 'Сквозная'

const DD_DEFAULT = 'Выбрать'

const defaultState = {
	cB600: true,
	num600: 2,
	cB800: false,
	num800: 2,
	aC300: false,
	numAC300: 2,
	aC400: false,
	numAC400: 2,
	aC600: false,
	numAC600: 2,
	height: DD_DEFAULT,
	deep: DD_DEFAULT,
	doorType: DD_DEFAULT,
	color: DD_DEFAULT,
	isolate: false,
	installation: FEET,
	connection: EXTERNAL,
	cable: false,
	corridorType: ISOLATED,
	enterType: ONE_WAY,
	changeWarning: false
}

const defaultContacts = {
	FIO: '',
	phone: '',
	email: ''
}

const defaultOptions = {
	heightOptions: [DD_DEFAULT],
	deepOptions: [DD_DEFAULT],
	doorTypeOptions: [DD_DEFAULT],
	colorOptions: [DD_DEFAULT],
	installationOptions: [FEET, NO_FEET],
	connectionOptions: [EXTERNAL, INTERNAL],
	corridorTypeOptions: [ISOLATED, NOT_ISOLATED],
	enterTypeOptions: [ONE_WAY, TWO_WAYS],
}

const defaultDisable = {
	enterDisabled: false
}

function CorridorConfigurator() {

	const [itemInfo, setItemInfo] = useState({})
	const [mainState, setMainState] = useState({
		...defaultState,
		...defaultOptions,
		...defaultDisable
	})
	const [list, setDBList] = useState({})
	const [showEnterTypeInfo, setShowEnterTypeInfo] = useState(false)
	const [specList, setSpecList] = useState([])

	const [locale, setLocale] = useState('ru')
	const [warnText, setWarnText] = useState('')
	const [showWarningFlag, setShowWarning] = useState(false)
	const [openModal, setOpenModal] = useState(false)
	const [btnClicked, setBtnClicked] = useState('')
	const [contacts, setContacts] = useState(...defaultContacts)

	React.useEffect(() => {
		loadDb()
	},[]);

	React.useEffect(() => {
		if ('cabinetList' in list){
			setDDOptions()
		}
	},[list]);

	React.useEffect(() => {
		if (!specList.length){
			setState('changeWarning',  false)
		}
	},[specList]);


// ++ Логика

const loadDb = () => {
	jQuery.getJSON(
		'itkcfg.php',
		{
			type: 'corridor',
			action: 'get'
		},
		db => {
			setItemList(db.list)
		}
	);
}

const setItemList = (list) => {
	const newArr = list.reduce((counter, item) => {
		switch (item.type) {
			case 'cabinet': counter.cabinetList.push(item); break;
			case 'panel': counter.panelList.push(item); break;
			case 'door': counter.doorList.push(item); break;
			case 'modul': counter.modulList.push(item); break;
			case 'enter': counter.enterList.push(item); break;
			case 'falsh': counter.falshList.push(item); break;
			case 'con': counter.conList.push(item); break;
			case 'kronsh': counter.kronshList.push(item); break;
			case 'air_isol': counter.airIsolList.push(item); break;
		}
		return counter
	}, {
		cabinetList:[],
		panelList:[],
		doorList:[],
		modulList:[],
		enterList:[],
		falshList:[],
		conList:[],
		kronshList:[],
		airIsolList:[]
	})
	setDBList(newArr)
}

const setDDOptions = () => {
	setHeight()
	setDeep()
	setDoorType()
	setColor()
}

const showWarning = (text) => {
	setWarnText(text)
	setShowWarning(true)
}

const clickAwayHandler = () => {
	closeWarn()
}

const closeWarn = () => {
	setShowWarning(false)
}

// ++ Отрпавка обратной связи

const sendToEmail = () => {
	if(contacts.FIO.length===0||contacts.phone.length===0||contacts.email.length===0){
		showWarning('Для продолжения заполните свои контактные данные.')
	}else if (!contacts.email.includes('@')){
		showWarning('Поле \'email\' должно содержать символ \'@\'')
	}else {
		jQuery.post(
			'itkcfg.php',
			{
				type: 'corridor',
				action: 'postForm',
				data: {
					specList: specList,
					contacts: contacts
				}
			}
		);
		let _params = {}
		switch (btnClicked) {
			case 'pdf':
				_params = {format: 'pdf'};
				_params.data = {
					specList: JSON.stringify(specList),
					showWarning: mainState.changeWarning
				};
				break;
			case 'excel':
				_params = {format: 'xls'};
				_params.data = {
					specList: JSON.stringify(specList),
					showWarning: mainState.changeWarning
				};
				break;
			case 'print':
				_params = {
					data: {
						specList: JSON.stringify(specList),
						showWarning: mainState.changeWarning
					}
				}
				break;
		}
		setOpenModal(false)
		doPrint(_params)
		setBtnClicked('')

	}
}

const	openModalForm = () => {
	setOpenModal(!openModal)
}

const	onContactsChange = (value, mark) => {
	setContacts((prevState) =>({...prevState, [mark]:value}))
}

// -- Отрпавка обратной связи



// ++ Для таблицы

const onListItemCheck = (item) => {
	jQuery.getJSON(
		'itkcfg.php',
		{
			type: 'corridor',
			action: 'getItemNSI',
			article: item.article
		},
		itemInfoFromServ => {
			setItemInfo(itemInfoFromServ)
		}
	)

}

const onDelete = (item) => {

	setSpecList(prevState => {
		const newArr = [...prevState]
		const groupIdx = newArr.findIndex(groupItem => item.groupID === groupItem.id)
		newArr[groupIdx].data = newArr[groupIdx].data.filter(listItem => listItem.article !== item.article)
		if( !newArr[groupIdx].data.length ) {
			newArr.splice(groupIdx,1)
		}
		return newArr
	})

	setState('changeWarning', true)

}

const onGroupDelete = (group) => {
	setSpecList(prevState => {
		let newArr = [...prevState]
		newArr = newArr.filter(groupItem => group.id !== groupItem.id)
		return newArr
	})
}
const onChangeQuantity = (item, value) => {
	setSpecList(prevState => {
		const newArr = [...prevState]
		const groupIdx = newArr.findIndex(groupItem => item.groupID === groupItem.id)
		newArr[groupIdx].data = newArr[groupIdx].data.map(dataItem => {
			if(dataItem.article === item.article){
				dataItem = {
					...dataItem,
					count: value
				}
			}
			return dataItem
		})
		return newArr
	})

	setState('changeWarning', true)

}

// -- Для таблицы

const getDivideList = (cabinetCount) => {

	let divideList = []
	let divideRegExp1
	if (!mainState.isolate) return []

	if (mainState.installation === FEET) {
		divideRegExp1 = /^ZP-SP\w{2}-\w{2}U-C-\w{4}-R$/
	} else {
		divideRegExp1 = /^ZP-SP\w{2}-\w{2}U-D-\w{4}-R$/
	}
	divideList.push(...list.panelList.filter(item => divideRegExp1.test(item.article)
	).map(item => {
		return {
			...item,
			count: cabinetCount - 2
		}
	}))
	divideList = divideList.filter(item => item.height === mainState.height)
	divideList = divideList.filter(item => item.depth === mainState.deep)
	divideList = divideList.filter(item => item.color === mainState.color)

	return divideList

}
const getDoorList = () => {

	let doorList = []
	if (mainState.enterDisabled) return doorList
	let doorRegExp1
	if (mainState.installation === FEET) {
		doorRegExp1 = /^ZP-FD\w{2}-\w{2}U-\w{4}-L-R$/
	}else{
		doorRegExp1 = /^ZP-FD\w{2}-\w{2}U-\w{4}-R$/
	}
	doorList.push(...list.doorList.filter(item => doorRegExp1.test(item.article)).map(item => {
		return {
			...item,
			count: mainState.enterType === ONE_WAY ? 1 : 2
		}
	}))
	doorList = doorList.filter(item => item.height === mainState.height)
	doorList = doorList.filter(item => item.depth === mainState.deep)
	doorList = doorList.filter(item => item.color === mainState.color)

	return doorList

}
const getWallList = () => {

	let wallList = []
	if (mainState.enterDisabled) return wallList
	let wallRegExp1 = /^ZP-PFD\w{2}-\w{2}U-\w{4}-R$/
	wallList.push(...list.panelList.filter(item => wallRegExp1.test(item.article)
	).map(item => {
		return {
			...item,
			count: mainState.enterType === ONE_WAY ? 1 : 0
		}
	}))
	wallList = wallList.filter(item => item.height === mainState.height)
	wallList = wallList.filter(item => item.depth === mainState.deep)
	wallList = wallList.filter(item => item.color === mainState.color)

	return wallList
}
const getConnectionList = (cabinetCount) => {

	let connectionList = []
	if(mainState.connection === EXTERNAL){
		connectionList.push(...list.conList.filter(item => item.article === 'ZP-CCK-E-R').map(item => {
			return {
				...item,
				count: cabinetCount - 2
			}
		}))
	} else {
		connectionList.push(...list.conList.filter(item => item.article === 'ZP-CCK-R').map(item => {
			return {
				...item,
				count: cabinetCount - 2
			}
		}))
	}

	return connectionList
}
const getCableList = (cabinetCount) => {

	let cableList = []
	if(mainState.cable){
		const cableRegExp1 = /^ZP-STB\w{2}-LG-\w{2}$/
		const cableRegExp2 = /^ZP-STB\w{2}-TB-\w{2}$/

		cableList.push(...list.kronshList.filter(item => cableRegExp1.test(item.article)).map(item => {
			return {
				...item,
				count: cabinetCount - (mainState.cB600 ? 2 : 0) - (mainState.cB800 ? 2 : 0)
			}
		}))

		if(mainState.cB600)  {
			cableList.push(...list.kronshList.filter(item => (cableRegExp2.test(item.article))
				&& item.width === '600').map(item => {
				return {
					...item,
					count: (mainState.cB600
						? Number(mainState.num600) < 4
							? 4
							: 8
						: 0)
				}
			}))
		}

		if(mainState.cB800)  {
			cableList.push(...list.kronshList.filter(item => (cableRegExp2.test(item.article))
				&& item.width === '800').map(item => {
				return {
					...item,
					count: (mainState.cB800
						? Number(mainState.num800) < 4
							? 4
							: 8
						: 0)
				}
			}))
		}
		cableList = cableList.filter(item => item.depth === mainState.deep)
		cableList = cableList.filter(item => item.color === mainState.color)
	}

	return cableList
}
const getPanelList = () => {

	let panelList = []
	if(mainState.corridorType !== ISOLATED) {
		const panelRegExp1 = /^ZP-SP\w{2}-\w{2}U-A-\w{4}-R$/
		panelList.push(...list.panelList.filter(item => panelRegExp1.test(item.article)).map(item => {
			return {
				...item,
				count: 4
			}
		}))
		panelList = panelList.filter(item => item.height === mainState.height)
		panelList = panelList.filter(item => item.depth === mainState.deep)
		panelList = panelList.filter(item => item.color === mainState.color)
	}
	return panelList
}
const getRoofList = () => {

	let roofList = []
	if (mainState.enterDisabled) return roofList
	const roofRegExp1 = /^ZP-R\w{2}-\w{4}-R$/
	const allRoofArray = [...list.modulList.filter(item => roofRegExp1.test(item.article))]

	if(mainState.cB600 || mainState.aC600){
		roofList.push(...allRoofArray.filter(item => item.width === '600').map(item => {
			return {...item, count: (mainState.cB600 ? Number(mainState.num600)/2 : 0) + (mainState.aC600 ? Number(mainState.numAC600)/2 : 0) }
		}))
	}

	if(mainState.cB800){
		roofList.push(...allRoofArray.filter(item => item.width === '800').map(item => {
			return {...item, count: Number(mainState.num800)/2}
		}))
	}

	if(mainState.aC300){
		roofList.push(...allRoofArray.filter(item => item.width === '300').map(item => {
			return {...item, count: Number(mainState.numAC300)/2}
		}))
	}

	if(mainState.aC400){
		roofList.push(...allRoofArray.filter(item => item.width === '400').map(item => {
			return {...item, count: Number(mainState.numAC400)/2}
		}))
	}
	roofList = roofList.filter(item => item.color === mainState.color)
	return roofList
}
const getFalshList = () => {

	let falshList = []
	const falshRegExp1 = /^ZP-FP\w{2}-\w{2}U-V-\w{3}-R$/
	const falshRegExp2 = /^ZP-FP\w{2}-\w{2}U-H-\w{3}-R$/

	if(mainState.cB600) {
		falshList.push(...list.falshList.filter(item => (falshRegExp1.test(item.article)
			|| falshRegExp2.test(item.article)) && item.width === '600').map(item => {
			return {
				...item,
				count: (mainState.cB600 ? Number(mainState.num600) : 0)
			}
		}))
	}

	if(mainState.cB800)  {
		falshList.push(...list.falshList.filter(item => (falshRegExp1.test(item.article)
			|| falshRegExp2.test(item.article)) && item.width === '800').map(item => {
			return {
				...item,
				count: (mainState.cB800 ? Number(mainState.num800) : 0)
			}
		}))
	}

	falshList = falshList.filter(item => item.height === mainState.height)
	falshList = falshList.filter(item => item.color === mainState.color)

	return falshList
}
const getEnterList = (cabinetCount) => {

	let enterList = []
	const enterRegExp1 = /^ZP-BE-\w{4}-R$/
	enterList.push(...list.enterList.filter(item => enterRegExp1.test(item.article)).map(item => {
		return {
			...item,
			count: cabinetCount * 2
		}
	}))
	enterList = enterList.filter(item => item.depth === mainState.deep)

	return enterList
}
const getAirIsolList = () => {

	let airIsolList = []
	const airIsolRegExp1 = /^ZP-PI-FB-\w{3}-R$/

	if (mainState.installation === FEET) {
		if(mainState.cB600) {
			airIsolList.push(...list.airIsolList.filter(item => airIsolRegExp1.test(item.article) && item.width === '600').map(item => {
				return {
					...item,
					count: (mainState.cB600 ? Number(mainState.num600) : 0)
				}
			}))
		}

		if(mainState.cB800) {
			airIsolList.push(...list.airIsolList.filter(item => airIsolRegExp1.test(item.article) && item.width === '800').map(item => {
				return {
					...item,
					count: (mainState.cB800 ? Number(mainState.num800) : 0)
				}
			}))
		}
	}

	return airIsolList
}

const setDefaultState = () => {
	setMainState((prevState) => ({
		...prevState,
		...defaultState,
		...defaultDisable,
	}))
}

const doPrint = (params) => {
	const _params = params || {};
	const $postForm = jQuery('<form action="print.php" method="post" target="_blank" accept-charset="UTF-8" />');

	let addHiddenField = function (name, value) {
		jQuery('<input type="hidden" />').attr('name', name).val(value).appendTo($postForm);
	};

	addHiddenField('type', 'corridor');

	if (_params.data) {
		Object.keys(_params.data).forEach(dataItemName => {
			addHiddenField(dataItemName, _params.data[dataItemName]);
		});
	}

	if (_params.format) {
		addHiddenField('format', _params.format);
	}

	if (locale) {
		addHiddenField('locale', locale);
	}

	$postForm.appendTo('body').submit().remove();
}

// ++ Кнопки

const onBtnCountClick = () => {

	if(!mainState.cB600 && !mainState.cB800
	){
		showWarning('Необходимо выбратьт хотя бы один из типов шкафов')
		return
	}

	if( mainState.height === DD_DEFAULT
		|| mainState.deep === DD_DEFAULT
		|| mainState.doorType === DD_DEFAULT
		|| mainState.color === DD_DEFAULT
	){
		showWarning('Все фильтры должны быть заполнены')
		return
	}

	// Расчет кафов
	let cabinetList = []
	let cabinetCount = 0
	if(mainState.cB600){
		cabinetList.push(...list.cabinetList.filter(item => item.width === '600').map(item => {
			return {...item, count: Number(mainState.num600)}
		}))
		cabinetCount = cabinetCount + Number(mainState.num600)
	}
	if(mainState.cB800){
		cabinetList.push(...list.cabinetList.filter(item => item.width === '800').map(item => {
			return {...item, count: Number(mainState.num800)}
		}))
		cabinetCount = cabinetCount + Number(mainState.num800)
	}
	cabinetList = cabinetList.filter(item => item.height === mainState.height)
	cabinetList = cabinetList.filter(item => item.depth === mainState.deep)
	cabinetList = cabinetList.filter(item => item.door_type === mainState.doorType)
	cabinetList = cabinetList.filter(item => item.color === mainState.color)

	// Расчет промежуточных
	const divideList = getDivideList(cabinetCount)
	// Расчет дверей
	const doorList = getDoorList()
	// Расчет количества торцевых панелей
	const wallList = getWallList()
	// Расчет способа соединения
	const connectionList = getConnectionList(cabinetCount)

	// Расчет Наличия кабельных трасс
	const cableList = getCableList(cabinetCount)

	const panelList = getPanelList()

	// Добавление крыш
	const roofList = getRoofList()

	// Добавление фальш панелей
	const falshList = getFalshList()

	// Добавление щеточного ввода
	const enterList = getEnterList(cabinetCount)

	// Добавление Панель изол. возд. пот.
	const airIsolList = getAirIsolList()

	let resultList = [...cabinetList, ...divideList, ...doorList, ...wallList, ...connectionList, ...cableList,
		...roofList, ...falshList, ...enterList, ...airIsolList]
	resultList = delDuplicatesFromArray([...resultList])
	resultList = resultList.filter(item => item.count > 0)

	resultList = resultList.map(item => {
		return {
			...item,
			groupID: specList.length + 'group'
		}
	})
	setSpecList((prevState) =>([ ...prevState, {id: prevState.length + 'group', data: [...resultList] }]))
	setDefaultState()
	setDDOptions()
}

const onClearBtnClick = () => {
	setDefaultState()
}

const onBtnPrintPdfClick = () => {
	if(!specList.length) {
		showWarning('Перед формированием отчета необходимо сформировать спецификацию')
		return
	}
	setOpenModal(true)
	setBtnClicked('pdf')
}

const onBtnPrintClick = () => {
	if(!specList.length) {
		showWarning('Перед формированием отчета необходимо сформировать спецификацию')
		return
	}
	setOpenModal(true)
	setBtnClicked('print')
}

const onBtnExcelClick = () => {

	if(!specList.length) {
		showWarning('Перед формированием отчета необходимо сформировать спецификацию')
		return
	}
	setOpenModal(true)
	setBtnClicked('excel')
}

// -- Кнопки

// -- Логика
// ++ Установка списка

const setHeight = () => {
	setState('heightOptions', getOptionsArray(list.cabinetList, 'height'))
}
const setDeep = () => {
	setState('deepOptions', getOptionsArray(list.cabinetList, 'depth'))
}
const setDoorType = () => {
	setState('doorTypeOptions', getOptionsArray(list.cabinetList, 'door_type'))
}
const setColor = () => {
	setState('colorOptions', getOptionsArray(list.cabinetList, 'color'))
}

// -- Установка списка

// ++  Служебные процедуры и функции

const getOptionsArray = (array, paramName) => {
	let res = []
	if(array.length){
		res = delDuplicatesFromArray(array.map((item) => {
			return item[paramName]
		}).filter(Boolean))
	}
	res.unshift(DD_DEFAULT)
	return res
}

// --  Служебные процедуры и функции

// ++ Обработка событий

const setState = (paramName, value) => {
	setMainState((prevState) =>({...prevState, [paramName]:value}))
}

// ++ Чекбоксы
const onCB600Change = (event) =>{
	setState('cB600', event.target.checked)
}
const onCB800Change = (event) =>{
	setState('cB800', event.target.checked)
}
const onIsolateChange = (event) =>{
	setState('isolate', event.target.checked)
}
const onCableChange = (event) =>{
	setState('cable', event.target.checked)
}
const onAC300Change = (event) =>{
	setState('aC300', event.target.checked)
}
const onAC400Change = (event) =>{
	setState('aC400', event.target.checked)
}
const onAC600Change = (event) =>{
	setState('aC600', event.target.checked)
}
// -- Чекбоксы

// ++ Инпуты
const onNum600Change = (event) =>{
	setState('num600', Number(event.target.value))
}
const onNum800Change = (event) =>{
	setState('num800', Number(event.target.value))
}
const onNumAC300Change = (event) =>{
	setState('numAC300', Number(event.target.value))
}
const onNumAC400Change = (event) =>{
	setState('numAC400', Number(event.target.value))
}
const onNumAC600Change = (event) =>{
	setState('numAC600', Number(event.target.value))
}
// -- Инпуты

// ++ Дропдауны
const onHeightChange = (event) =>{
	setState('height', event.target.value)
}
const onDeepChange = (event) =>{
	setState('deep', event.target.value)
}
const onDoorTypeChange = (event) =>{
	setState('doorType', event.target.value)
}
const onColorChange = (event) =>{
	setState('color', event.target.value)
}
// -- Дропдауны

// ++ Радио
const onInstallationChange = (event) =>{
	setState('installation', event.target.value)
}
const onConnectionChange = (event) =>{
	setState('connection', event.target.value)
}
const onCorridorTypeChange = (event) =>{
	setState('enterDisabled', event.target.value === NOT_ISOLATED)
	setState('corridorType', event.target.value)
}
const onEnterTypeChange = (event) =>{
	setState('enterType', event.target.value)
}
// -- Радио

// -- Обработка событий


// ++ Отрисовка

// ++ Основные компоненты
const getFilters = () => {
	let elements = [];

	elements.push(<CheckBoxWithHeader
			x={16}
			y={35}
			labelX={50}
			labelY={40}
			widthLbl={180}
			title='Шкаф шириной 600мм'
			key={'filters' + elements.length}
			onChange={onCB600Change}
			value={mainState.cB600}
			type='cb600'
		/>
	)

	elements.push(<Input
		key={'filters' + elements.length}
		x={220}
		y={25}
		labelWidth={150}
		width={105}
		title='Количество шкафов:'
		type = 'number'
		min={2}
		max={998}
		step={2}
		onChange={onNum600Change}
		onBlur={onNum600Change}
		value={mainState.num600}
		disabled={!mainState.cB600}
	/>)

	elements.push(<CheckBoxWithHeader
			x={16}
			y={90}
			labelX={50}
			labelY={95}
			widthLbl={180}
			title='Шкаф шириной 800мм'
			key={'filters' + elements.length}
			onChange={onCB800Change}
			value={mainState.cB800}
			type='cb800'
		/>
	)

	elements.push(<Input
		key={'filters' + elements.length}
		x={220}
		y={80}
		labelWidth={150}
		width={105}
		title='Количество шкафов:'
		type = 'number'
		min={2}
		max={998}
		step={2}
		onChange={onNum800Change}
		onBlur={onNum800Change}
		value={mainState.num800}
		disabled={!mainState.cB800}
	/>)

	elements.push(<DropDown
		x={20}
		y={140}
		width={105}
		title='Высота, мм:'
		key={'filters' + elements.length}
		onChange={onHeightChange}
		value={mainState.height}
		options={mainState.heightOptions}
	/>)

		elements.push(<DropDown
			x={145}
			y={140}
			width={105}
			title='Глубина, мм:'
			key={'filters' + elements.length}
			onChange={onDeepChange}
			value={mainState.deep}
			options={mainState.deepOptions}
		/>)

			elements.push(<DropDown
				x={270}
				y={140}
				width={105}
				title='Тип дверей:'
				key={'filters' + elements.length}
				onChange={onDoorTypeChange}
				value={mainState.doorType}
				options={mainState.doorTypeOptions}
			/>)

		elements.push(<DropDown
			x={20}
			y={195}
			width={105}
			title='Цвет:'
			key={'filters' + elements.length}
			onChange={onColorChange}
			value={mainState.color}
			options={mainState.colorOptions}
		/>)

				elements.push(<CheckBoxWithHeader
						x={16}
						y={250}
						labelX={50}
						labelY={255}
						title='Изолированное пространство между шкафами'
						key={'filters' + elements.length}
						onChange={onIsolateChange}
						value={mainState.isolate}
						type='isolate'
					/>
				)

					elements.push(<div
						key={'filters' + elements.length}
						style={{
							position: 'absolute',
							left:'20px',
							top:'290px'
						}}>Способ установки:</div>)

					elements.push(<RadioGroup
						key={'filters' + elements.length}
						type='installation'
						x={150}
						y={285}
						labelWidth={70}
						options={mainState.installationOptions}
						value={mainState.installation}
						onChange={onInstallationChange}
					/>)

					elements.push(<div
						key={'filters' + elements.length}
						style={{
							position: 'absolute',
							left:'20px',
							top:'330px'
						}}>Способ соединения:</div>)

					elements.push(<RadioGroup
						key={'filters' + elements.length}
						type='connection'
						x={150}
						y={325}
						labelWidth={70}
						options={mainState.connectionOptions}
						value={mainState.connection}
						onChange={onConnectionChange}
					/>)

						elements.push(<CheckBoxWithHeader
								x={16}
								y={360}
								labelX={50}
								labelY={365}
								title='Наличие кабельных трас с опорой на шкафы'
								key={'filters' + elements.length}
								onChange={onCableChange}
								value={mainState.cable}
								type='cable'
							/>
						)

							elements.push(<div
								key={'filters' + elements.length}
								style={{
									position: 'absolute',
									left:'20px',
									top:'400px'
								}}>Тип коридоров:</div>)

							elements.push(<RadioGroup
								key={'filters' + elements.length}
								type='corridorType'
								x={120}
								y={395}
								distance={130}
								labelDistance={25}
								labelWidth={105}
								options={mainState.corridorTypeOptions}
								value={mainState.corridorType}
								onChange={onCorridorTypeChange}
							/>)

								elements.push(<div
									key={'filters' + elements.length}
									style={{
										position: 'absolute',
										left:'20px',
										top:'435px'
									}}>Тип входной группы:</div>)

								elements.push(<div key={'filters' + elements.length}>
									<span className={styles.enterTypeInfo}
												onPointerEnter={() => setShowEnterTypeInfo(true)}
												onPointerLeave={() => setShowEnterTypeInfo(false)}>&#63;</span>
									{showEnterTypeInfo
										&& <span className={styles.showEnterTypeInfo}>
												При выборе сквозной входной группы в комплект будут добавлены 2 раздвижные двери. При выборе группы с одном входом
											в комплект будут добавлены 1 раздвижная дверь и 1 торцевая глухая панель</span>}
								</div>)

								elements.push(<RadioGroup
									key={'filters' + elements.length}
									type='enterType'
									x={165}
									distance={138}
									y={432}
									labelDistance={25}
									disabled={mainState.enterDisabled}
									labelWidth={90}
									options={mainState.enterTypeOptions}
									value={mainState.enterType}
									onChange={onEnterTypeChange}
								/>)


	// elements.push(<CheckBoxWithHeader
	// 		x={16}
	// 		y={480}
	// 		labelX={50}
	// 		labelY={485}
	// 		widthLbl={180}
	// 		title='Кондиционер шириной 300мм'
	// 		key={'filters' + elements.length}
	// 		onChange={onAC300Change}
	// 		value={mainState.aC300}
	// 		type='aC300'
	// 		disabled={mainState.enterDisabled}
	// 	/>
	// )
	//
	// elements.push(<Input
	// 	key={'filters' + elements.length}
	// 	x={230}
	// 	y={470}
	// 	labelWidth={170}
	// 	width={105}
	// 	title='Количество кондиционерв:'
	// 	type = 'number'
	// 	min={2}
	// 	max={998}
	// 	step={2}
	// 	onChange={onNumAC300Change}
	// 	onBlur={onNumAC300Change}
	// 	value={mainState.numAC300}
	// 	disabled={!mainState.aC300 || mainState.enterDisabled}
	// />)
	//
	// elements.push(<CheckBoxWithHeader
	// 		x={16}
	// 		y={535}
	// 		labelX={50}
	// 		labelY={540}
	// 		widthLbl={180}
	// 		title='Кондиционер шириной 400мм'
	// 		key={'filters' + elements.length}
	// 		onChange={onAC400Change}
	// 		value={mainState.aC400}
	// 		type='aC400'
	// 		disabled={mainState.enterDisabled}
	// 	/>
	// )
	//
	// elements.push(<Input
	// 	key={'filters' + elements.length}
	// 	x={230}
	// 	y={525}
	// 	labelWidth={170}
	// 	width={105}
	// 	title='Количество кондиционерв:'
	// 	type = 'number'
	// 	min={2}
	// 	max={998}
	// 	step={2}
	// 	onChange={onNumAC400Change}
	// 	onBlur={onNumAC400Change}
	// 	value={mainState.numAC400}
	// 	disabled={!mainState.aC400 || mainState.enterDisabled}
	// />)
	//
	// elements.push(<CheckBoxWithHeader
	// 		x={16}
	// 		y={590}
	// 		labelX={50}
	// 		labelY={595}
	// 		widthLbl={180}
	// 		title='Кондиционер шириной 600мм'
	// 		key={'filters' + elements.length}
	// 		onChange={onAC600Change}
	// 		value={mainState.aC600}
	// 		type='aC600'
	// 		disabled={mainState.enterDisabled}
	// 	/>
	// )
	//
	// elements.push(<Input
	// 	key={'filters' + elements.length}
	// 	x={230}
	// 	y={580}
	// 	labelWidth={170}
	// 	width={105}
	// 	title='Количество кондиционерв:'
	// 	type = 'number'
	// 	min={2}
	// 	max={998}
	// 	step={2}
	// 	onChange={onNumAC600Change}
	// 	onBlur={onNumAC600Change}
	// 	value={mainState.numAC600}
	// 	disabled={!mainState.aC600 || mainState.enterDisabled}
	// />)

	return elements
}
// -- Основные компоненты
// ++ Кнопки
const getCustomButtons = () => {
	let elements = [];

	elements.push(
		<button
			style={{top: '590px', left: '20px'}}
			className={styles.smallButton}
			onClick={onBtnCountClick}
			key={'count'}
		>Расчет</button>
	);


	elements.push(
		<button
			style={{top: '590px', left: '200px'}}
			className={styles.smallButton}
			onClick={onClearBtnClick}
			key={'clear'}
		>Сбросить</button>
	)

	elements.push(
		<Button
			x="784"
			y="764"
			buttonStyle={styles.mainBtn}
			textStyle={styles.mainBtnText}
			iconStyle={styles.pdfBtnIcon}
			text="Сохранить в PDF"
			onClick={onBtnPrintPdfClick}
			key="printpdf"
		/>
	);

	elements.push(
		<Button
			x="988"
			y="764"
			buttonStyle={styles.mainBtn}
			textStyle={styles.mainBtnText}
			iconStyle={styles.printBtnIcon}
			text="Распечатать"
			onClick={onBtnPrintClick}
			key="print"
		/>
	);

	elements.push(
		<Button
			x="1192"
			y="764"
			buttonStyle={styles.mainBtn}
			textStyle={styles.mainBtnText}
			iconStyle={styles.excelBtnIcon}
			text="Сохранить в Excel"
			onClick={onBtnExcelClick}
			key="excel"
		/>
	);

	return elements
}
// -- Кнопки
// -- Отрисовка


	return (<div className={styles.cfg}>
		{/*Белый фон и лого*/}
		<div style={{
			position: 'absolute',
			margin: '0 auto',
			backgroundColor: '#fff',
			width: '13%',
			height: '80px'
		}}/>
		<Image
			className={styles.logo}
			blockChangeScale={true}
		/>
		{/*Оранжевый фон заголовка*/}
		<div style={{
			margin: '0 auto',
			backgroundColor: '#76d750',
			width: '100%',
			height: '80px'
		}}>
			<div className={styles.title}>Изолированный коридор</div>
		</div>

		{
			showWarningFlag
				? <Popup
					warningText={warnText}
					type={'itk'}
					onClick={clickAwayHandler}
				/>
				: null
		}

		{/*Левая Часть*/}
		<div style={{
			position: 'absolute',
			top: '100px',
			left: '20px',
			width: '400px',
			height: '470px',
			backgroundColor: '#fff'
		}}
		>
			{getFilters()}
		</div>

		{/*Центр*/}
		<Table
			title='Корзина'
			type='Bucket'
			items={specList}
			styles={{width: '480px', height: '560px', top: '100px', left: '440px', fontSize: '12px'}}
			onSelect={onListItemCheck}
			onDelete={onDelete}
			onGroupDelete={onGroupDelete}
			onChangeQuantity={onChangeQuantity}
			color='#76d750'
			configType='corridor'
		/>

		{ mainState.changeWarning
			?
			<div style={{
				position: 'absolute',
				color: 'red',
				top: '725px',
				left: '440px'
			}}>
				Стандартная конфигурация коридора была изменена
			</div>
			: null
		}

		{/*Кнопки*/}
		{getCustomButtons()}

		{/*Правая часть*/}
		{/* Артикул и имя */}
		<div className={styles.itemInfoBG}/>
		{itemInfo && itemInfo[0] ? (
			<a href={`https://qr.iek.group/${itemInfo && itemInfo[0] && itemInfo[0].art}`}
				 target="_blank">
				<div className={styles.itemInfo}>
					<div className={styles.itemInfo_Article}>{itemInfo && itemInfo[0] && itemInfo[0].art}</div>
					<div>{itemInfo && itemInfo[0] && itemInfo[0].name}</div>
				</div>
			</a>
		) : (
			<div className={styles.itemInfoNoArticle}/>
		)}

		{/* Фото */}
		<Image
			className={styles.itemImg + ' ' +
				(itemInfo && itemInfo.length === 0 ? styles.warn : '')}
			url={itemInfo && itemInfo[0] && itemInfo[0].ImgPng[0].file_ref.uri ? itemInfo[0].ImgPng[0].file_ref.uri : null}
		/>

		{/* Описание */}
		<div style={{
			position: 'absolute',
			top: '452px',
			left: '940px',
			backgroundColor: '#fff',
			width: '434px',
			height: '292px'
		}}/>
		{itemInfo && itemInfo[0] && itemInfo[0].Description[0].desc_ru ? (
			<div className={styles.description}>
				{itemInfo[0].Description[0].desc_ru}
			</div>
		) : itemInfo && itemInfo.length === 0 ? (
				<div className={styles.description}>
					На сайте временно веутся технические работы. Некоторые данные могут быть недоступны
				</div>
			)
			: (
				<div className={styles.descriptionEmpty}>
				</div>
			)}

		<div style={{
			position: 'absolute',
			top: '760px',
			left: '360px',
			fontSize: '15px',
			lineHeight: '16px',
			width: '400px'
		}}
		>
			Данный конфигуратор служит для подбора стандартного решения. Для подбора уникальных решений обратитесь по адресу:	mazhukinrv@itk-group.ru
		</div>

		{openModal &&
			<Modal sendToEmail={sendToEmail} toggleModal={openModalForm} onChange={onContactsChange}/>}

		{/*Нижняя плашка*/}
		{/* На основной сайт IEK */}
		<div style={{position:'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top:'820px'}}/>
		<a  className={styles.homeLink} href={'https://www.itk-group.ru/'} target="_blank">На основной сайт ITK</a>

		{/* Техническая поддержка */}
		<div style={{position:'absolute', backgroundColor: '#76d750', width: '50%', height: '20px', top:'820px', left: '700px'}}/>
		<a style={{
			position: 'absolute',
			top: '823px',
			left: '415px',
			color: '#37424a',
			width: '141px',
			height: '14px'
		}}
			 href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
		</a>
		<span className={styles.techSupport}>+7 (495) 542-22-27</span>

	</div>)
}

export default CorridorConfigurator



// WEBPACK FOOTER //
// ./src/react/CorridorConfigurator.jsx